import { Box, Container, Divider, Typography } from "@mui/material";
import { DbProvider } from "../services/db/DbProvider";
import { type Event } from "../src/types/eventTypes";
import { EventCalendar, EventCardLarge } from "@components/Events/Events";
import { useScreenSize } from "../src/hooks/useScreenSize";
import { useContext } from "react";
import { LocalizationContext } from "../src/lib/context";
import EventMessages from "@components/Events/EventMessages";

export async function getStaticProps() {
  const db = new DbProvider();
  let events: Event[] = [];
  try {
    events = await db.getAll(null, null, "events");
  } catch (e) {
    return {
      props: { events: [] },
    };
  }
  events = events.filter((event) => event.date);
  const modEvents: Event[] = events
    .filter((event) => event.date > Date.now())
    .sort((a, b) => a.date - b.date);
  return {
    props: { events: modEvents },
    revalidate: 60,
  };
}

export default function Events({ events }: { events: Event[] }) {
  const { eventsPage } = useContext(LocalizationContext).localeStrings;
  const isThereAnUpcomingEvent =
    events.length > 0 && events[0].date > Date.now();
  const md = useScreenSize("md", "up");
  const lg = useScreenSize("lg", "up");
  return (
    <div>
      <Container
        className="col pb-extra pt-extra"
        style={{ maxWidth: lg ? "80%" : "100%" }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography className="pt-huge" variant="h1">
          {eventsPage.pageTitle}
        </Typography>
        <Typography className="pt-large" variant="h2">
          {events.length > 0 && isThereAnUpcomingEvent
            ? md
              ? eventsPage.upcomingSingular
              : eventsPage.upcomingPlural
            : eventsPage.noEvents}
        </Typography>
        {isThereAnUpcomingEvent && (
          <>
            <EventCardLarge event={events[0]} />
            {!md && events[1] && <EventCardLarge event={events[1]} />}
          </>
        )}
        {md && (
          <>
            <Typography className="pt-large" variant="h2">
              {eventsPage.calendarTitle}
            </Typography>
            <EventCalendar events={events} />
          </>
        )}
        <Box className="mt-extra">
          <EventMessages events={events} />
        </Box>
      </Container>
      <div style={{ marginBottom: 20 }} className="bottomInfo">
        <div className="bottomInfo__main">
          <div className="bottomInfo__header">{eventsPage.pageTitle}</div>
          <Divider />
          {eventsPage.seoText
            .split("\n\n")
            .map(
              (paragraph, index) =>
                paragraph && <Typography key={index}>{paragraph}</Typography>
            )}
        </div>
      </div>
    </div>
  );
}
